// extracted by mini-css-extract-plugin
export default {"stockList":"index_stockList_mHAgW","red":"index_red_ZNk6m","current":"index_current_ETpcE"};